<template>
	<div>
		<InputRow label="Type">
			<select v-model="addPayment.mode">
				<option value="0">Deposit (positive amount) - Customer paid</option>
				<option value="1">Withdrawal (negative amount) - We refunded</option>
			</select>
		</InputRow>

		<InputRow label="Transfer to">
			<input type="text" class="small-margin-right" maxlength="4" style="width: 60px" placeholder="Reg no." v-model="addPayment.regNo" />
			<input type="text" placeholder="Account No" v-model="addPayment.accountNo" v-on:keyup.enter="createPayment()" />
		</InputRow>

		<InputRow label="Amount">
			<input type="text" placeholder="Reg no." v-model="addPayment.amount" v-on:keyup.enter="createPayment()" />
		</InputRow>

		<InputRow label="Transfer date">
			<input type="text" placeholder="YYYY-MM-DD" v-model="addPayment.transferDate" v-on:keyup.enter="createPayment()" />
		</InputRow>

		<InputRow label="Order no.">
			<input type="text" v-model="addPayment.orderId" v-on:keyup.enter="createPayment()" />
		</InputRow>

		<!-- <InputRow label="Customer no.">
			<input type="text" v-model="addPayment.customerId" v-on:keyup.enter="createPayment()" />
		</InputRow> -->

		<InputRow label="Comment">
			<input type="text" style="width: 500px;" maxlength="180" v-model="addPayment.comment" v-on:keyup.enter="createPayment()" />
		</InputRow>

		<InputRow label="Reason">
			<select v-model="addPayment.reason">
				<option value="failed-payment">Compensating for failed credit card payment</option>
				<option value="">Other</option>
			</select>
		</InputRow>

		<div class="margin-top">
			<button :disabled="saving" v-on:click="createPayment();">Create</button>
			<button v-if="cancelbutton" v-on:click="$emit('cancel')" class="gray small-margin-left">Cancel</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'orderid',
    'countryId',
    'cancelbutton'
  ],
  data: () => ({
    saving: false,
    addPayment: {
      mode: 0,
      regNo: '',
      accountNo: '',
      amount: 0,
      reason: '',
      orderId: '',
      customerId: '',
      comment: ''
    }
  }),
  methods: {
    createPayment () {
      Vue.api.post('/bank-payment', this.addPayment, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$emit('created')
      })
    }
  },
  created () {
    if (this.orderid) {
      this.addPayment.orderId = this.orderid
    }
  }
}
</script>
